module.exports = __webpack_public_path__ + "static/img/template_2.4a20ad0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/template_2.jpg
// module id = 3RWg
// module chunks = 92